import { PaletteMode, ThemeOptions } from '@mui/material';
import palette from '../partials/palette.css';
import { vars } from '../vars.css';
import { colorValues } from '../partials/colorValues';

export const getThemePalette = (mode: PaletteMode): ThemeOptions['palette'] => {
  const isDark = mode === 'dark';

  return {
    mode,
    primary: {
      main: colorValues.black.main,
      contrastText: colorValues.white.main,
    },
    secondary: {
      main: colorValues.black.main,
      contrastText: colorValues.white.main,
    },
    divider: isDark ? colorValues.white.main : colorValues.black.main,
    background: {
      ...(isDark
        ? {
            paper: colorValues.black.main,
          }
        : {
            paper: colorValues.white.main,
          }),
    },
  };
};
